/**
 * Servicio para migración y limpieza de datos al iniciar la aplicación
 */
import { Injectable, inject } from '@angular/core';
import { MigrationService } from './migration.service';
import { LogService } from './log.service';

@Injectable({ providedIn: 'root' })
export class MigrationInitializerService {
  private readonly migrationService = inject(MigrationService);
  private readonly logger = inject(LogService);

  async initialize(): Promise<void> {
    try {
      this.logger.info('[MigrationInitializerService] Iniciando migración inicial');

      const status = await this.migrationService.getCleanStatus();

      this.logger.info('[MigrationInitializerService] Estado actual', {
        remitosPendientes: status.remitos,
        ubicacionesPendientes: status.ubicaciones
      });

      await this.migrationService.cleanLegacyData();

      this.logger.info('[MigrationInitializerService] Migración inicial completada');
    } catch (error) {
      this.logger.error('[MigrationInitializerService] Error en migración inicial', {
        error: error instanceof Error ? error.message : String(error)
      });
    }
  }
}
